import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-loader",
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule],
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
    show = input<boolean>(false);
    diameter = input<number>(100);
    strokeWidth = input<number>(8);
}
